import { pushToDataLayer } from '@domain-group/fe-helper';

import * as ga from '../../../constants/ga';

const agencyAddressClick = () =>
  pushToDataLayer({
    event: ga.event,
    eventAction: 'Agent Profile',
    eventCategory: ga.category.INTERACTION,
    eventLabel: 'Agent Address Click',
  });

export default agencyAddressClick;
